import * as palette from "@govlaunch/palette";

import Downshift from "downshift";
import Menu from "./elements/Menu";
import Option from "./options/Option";
import OptionsWrapper from "./options/OptionsWrapper";
import Placeholder from "./options/Placeholder";
import PropTypes from "prop-types";
import React, { useState } from "react";
import SelectInput from "./elements/SelectInput";
import TopBottomChevron from "./elements/TopBottomChevron";
import get from "lodash/fp/get";

export default function Select({
  value,
  onChange,
  onFocus,
  onBlur,
  placeholder,
  validationState,
  items,
  size,
  native,
}) {
  const [isOpen, setOpen] = useState(false);
  const selectedValue = value !== null && typeof value === "object" && value.value === null ? null : value;

  if (native) {
    return (
      <SelectInput
        isOpen={isOpen}
        native={true}
        validationState={validationState}
        size={size}
        onFocus={onFocus}
        onBlur={onBlur}
        onClick={() => setOpen(!isOpen)}
        onChange={event => onChange(event.currentTarget.value)}
        value={selectedValue && typeof selectedValue === "object" ? selectedValue.value : selectedValue || ""}
      >
        {items.map(({ value, label }) => {
          return (
            <option key={`${value}--${label}`} value={value}>
              {label}
            </option>
          );
        })}
      </SelectInput>
    );
  }

  return (
    <Downshift itemToString={get("value")} onChange={value => onChange(value)} selectedItem={selectedValue}>
      {({ selectedItem, getToggleButtonProps, getItemProps, isOpen, highlightedIndex }) => (
        <div>
          <SelectInput
            isOpen={isOpen}
            {...getToggleButtonProps()}
            validationState={validationState}
            size={size}
            onFocus={onFocus}
            onBlur={onBlur}
          >
            {selectedItem ? (
              <div
                css={{
                  fontSize: 14,
                  letterSpacing: 0.5,
                  lineHeight: 1.14,
                  fontWeight: 500,
                  color: palette.primary,
                  boxSizing: "border-box",
                }}
              >
                {selectedItem.label}
              </div>
            ) : (
              <Placeholder>{placeholder}</Placeholder>
            )}

            <TopBottomChevron />
          </SelectInput>

          {isOpen && (
            <Menu
              css={{
                marginTop: 0,
              }}
            >
              <OptionsWrapper>
                {items.map((item, index) => (
                  <Option
                    key={item.value}
                    {...getItemProps({
                      item,
                      active: highlightedIndex === index,
                    })}
                  >
                    {item.label}
                  </Option>
                ))}
              </OptionsWrapper>
            </Menu>
          )}
        </div>
      )}
    </Downshift>
  );
}

Select.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string.isRequired,
  validationState: PropTypes.string,
  items: PropTypes.array.isRequired,
  size: PropTypes.string,
  native: PropTypes.bool,
};

Select.defaultProps = {
  value: null,
  validationState: null,
  size: null,
  onFocus: null,
  onBlur: null,
  native: false,
};
